export default __webpack_public_path__ + "static/media/verrilli.d277380e.jpg";